module.exports = __webpack_public_path__ + "static/media/apple-store.6fc6b941.png";